import { applyCobrandingBootTheme } from './bootTheme';

// Run before the main React dependency graph evaluates. The implementation is
// registry-gated and remains a no-op for experiences that have not opted in.
applyCobrandingBootTheme();
